<script>
import { mapActions, mapGetters } from 'vuex'
import tracker from './components/tracker.vue'
import leaflet from './components/leaflet.vue'
import commitments from './components/commitments.vue'

export default {
  name: 'App',
  components: {
    tracker,
    leaflet,
    commitments
  },
  data() {
    return {
      disclaimer_text: window.Drupal.t("Please note that climate actions are happening every day in every province and territory, big and small. The above map is only tracking actions associated with the GenAction initiative, and your pledges.")
    }
  },
  created() {
    this.fetchCommitments()
  },
  computed: {
    ...mapGetters({
      total: 'getTotal'
    })
  },
  methods: {
    ...mapActions({
      fetchCommitments: 'fetchCommitments'
    })
  }
}
</script>
<template>
  <div id="app">
    <div class="action-tracker">
      <tracker />
      <leaflet />
    </div>
    <div class="disclaimer">
      <p>{{ this.disclaimer_text }}</p>
    </div>
    <commitments v-if="total > 0" :count="total" />
  </div>
</template>
<style scoped>
h2,
h3 {
  font-family: futuramedium !important;
}

h3 {
  font-size: 1.625rem;
  font-weight: 600;
  color: #000;
  margin: 0.2rem 0;
}

#app {
  display: flex;
  flex-direction: column;
}

#app,
.genaction-map {
  width: 100%;
}

.action-tracker {
  display: flex;
  width: 100%;
  height: auto;
  min-height: 300px;
  flex-direction: row;
  flex-wrap: wrap;
}

#sidebar,
#map {
  width: 100%;
  height: 100%;
}

.disclaimer {
  padding: 0.5rem;
  border-radius: 2px;
  margin-top: 1rem;
  background-color: #efefefef;
  text-align: center;
}

/* @media screen and (min-width: 780px) {
      #sidebar {
          width: 30%;
      }
      #map {
          width: 70%;
      }  
  } */
</style>
